module.exports = __webpack_public_path__ + "static/media/fm-icons-FM_light.f22d9e13.svg";